'use strict';

var React = require('react');

var SvgCircleDisableMinor = function SvgCircleDisableMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 10c0-1.294.416-2.49 1.115-3.471l8.356 8.356a5.961 5.961 0 0 1-3.471 1.115c-3.309 0-6-2.691-6-6zm12 0c0 1.294-.416 2.49-1.115 3.471l-8.356-8.356a5.961 5.961 0 0 1 3.471-1.115c3.309 0 6 2.691 6 6zm-14 0c0 4.411 3.589 8 8 8s8-3.589 8-8-3.589-8-8-8-8 3.589-8 8z"
  }));
};

exports.SvgCircleDisableMinor = SvgCircleDisableMinor;
